export default __webpack_public_path__ + "static/media/btn_step_4_hover.c8500bd9.svg";